export enum ELanguage {
  VI = 'vi',
  EN = 'en',
}